import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import { AppShell } from "@/components/AppShell";

import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import Clients from "@/pages/Clients";
import Tasks from "@/pages/Tasks";
import Leads from "@/pages/Leads";
import Conversations from "@/pages/Conversations";

function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === null) {
        return (
            <div className="min-h-screen bg-[#050505] grid place-items-center text-zinc-500 text-sm">
                <span className="h-2 w-2 rounded-full bg-[#0066FF] elate-breathe inline-block mr-2" />
                Loading Elate OS…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    return <AppShell>{children}</AppShell>;
}

function RootRedirect() {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen bg-[#050505] grid place-items-center text-zinc-500 text-sm">
                <span className="h-2 w-2 rounded-full bg-[#0066FF] elate-breathe inline-block mr-2" />
                Loading Elate OS…
            </div>
        );
    }
    return <Navigate to={user ? "/app" : "/login"} replace />;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster theme="dark" position="bottom-right" />
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />

                        <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                        <Route path="/app/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
                        <Route path="/app/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
                        <Route path="/app/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
                        <Route path="/app/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
                        <Route path="/app/conversations" element={<ProtectedRoute><Conversations /></ProtectedRoute>} />

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
